"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderEmiCardClickDL } from "./HeaderAnalyticsFunction";

interface HeaderEMICardProps {
  headerEMICard?: {
    ctaInNewTab: string;
    ctaLink: string;
    heading: string;
    isActiveClass: string;
    key: string;
    sectionID: string;
    showOnApp: string;
    showOnWeb: string;
    template: string;
  };
}

const EMICard: React.FC<HeaderEMICardProps> = (props) => {
  const { headerEMICard } = props;
  const heading = headerEMICard?.heading ?? "EMI Card";
  const link = headerEMICard?.ctaLink ?? "";
  const openInNewTab = headerEMICard?.ctaInNewTab === "true" || false;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // Track analytics before navigation
    handleHeaderEmiCardClickDL(heading, link);

    // Navigate after analytics completes
    if (openInNewTab) {
      window.open(link, "_blank");
    } else {
      window.location.href = link;
    }
  };

  return (
    <BFLLink
      href={link}
      aria-label={heading}
      onClick={handleClick}
      className="order-3 m-0 flex flex-col items-center px-2 pt-[14px] pb-[30px] hover:bg-[#001326] md:order-2"
    >
      <i className="icomoon text-2xl before:content-['\e955']"></i>
      <span className="hidden text-xs leading-[14px] whitespace-nowrap md:!block">{heading}</span>
    </BFLLink>
  );
};
export default EMICard;
